import { render, staticRenderFns } from "./superlog.vue?vue&type=template&id=639bd3c9&"
import script from "./superlog.vue?vue&type=script&lang=js&"
export * from "./superlog.vue?vue&type=script&lang=js&"
import style0 from "./superlog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports